export const APP_ICON_SRC = `${process.env.PUBLIC_URL}/images/app_icon.svg`;
export const APP_ICON_WIDTH = 56;
export const APP_ICON_HEIGHT = 84;
